import { FormatterService } from "@/domain/services";
import moment from "moment";

export class DateFormatter implements FormatterService {
  maxLength: number = 8;

  format(value: string, format: string = "DD/MM/YYYY"): string {
    const date = moment(value);
    const now = moment();

    if (now.isSame(date, "date")) return "Hoje";
    if (now.subtract(1, "day").isSame(date, "date")) return "Ontem";
    const formatted = moment(value).format(format);
    return this.capitalizeFirstLetter(formatted);
  }

  reverse(value: string): string {
    if (!value) return "";
    const date = value.split("/");
    return `${date[2]}-${date[1]}-${date[0]}`;
  }

  moment(value: string) {
    return moment(value);
  }

  private capitalizeFirstLetter(str: string): string {
    return str.replace(/[a-zA-Z]/, (match) => match.toUpperCase());
  }
}
